<template>
    <div :class="'bizcomp-service-subscript bizcomp ' + className">
        <div>
            <div v-for="(item, index) in serviceSubscriptionArr" :key="index">
                <div class="service-subscript-head margin-l-30">
                    <div class="service-subscript-head-bar"></div>
                    <div class="service-subscript-head-text">{{ item.groupName }}</div>
                </div>

                <div class="service-subscript-content">
                    <div v-for="sub in item.checkedObj" :key="sub.columno" class="el-row-common">
                        <div v-if="sub.type === 'img'" class="single-row-img">
                            <img
                                v-if="$cache.getCompanyInfoParam(sub.columno)"
                                :src="
                                    $util.imgSrc({
                                        fileCode: $cache.getCompanyInfoParam(sub.columno)
                                    })
                                "
                                height="60"
                            />
                            <span class="single-row-img-text">{{ sub.columName }}</span>
                        </div>
                        <div v-else class="single-row">
                            <span>{{ sub.columName }}</span>
                            <el-checkbox
                                v-model="sub.status"
                                size="mini"
                                text-color="red"
                                :disabled="$cache.getUser().custnoCrm ? false : true"
                                v-on:change="handleCheck"
                            ></el-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";
export default {
    name: "ServiceSubscriptDc",
    components: {},
    mixins: [mixin],
    data() {
        return {
            info: {},
            serviceSubscriptionArr: [],
            timer: null
        };
    },
    created() {
        this.info = this.$cache.getUser();
        this.qryCustomizedServer();
        if (!this.$cache.getUser().custnoCrm) {
            this.$confirm("当天开户不允许信息订阅，请下一工作日再尝试!", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                showCancelButton: false
            }).then(() => {});
        }
    },
    mounted() {
        this.serviceSubscriptionArr =
            (this.$cache.getParamValue("customized_server") &&
                this.$cache.getParamValue("customized_server").customized_server) ||
            [];
    },
    methods: {
        async qryCustomizedServer() {
            const checkeInfos = await userApi.qryCustomizedServer({
                qrytype: "a"
            });
            if (checkeInfos && checkeInfos.data) {
                this.serviceSubscriptionArr.forEach((group) => {
                    group.checkedObj.forEach((option) => {
                        // 在API返回数据中查找匹配项
                        const matchedItem = checkeInfos.data.find(
                            (item) => item.columno == option.columno
                        );

                        if (matchedItem) {
                            if (option.columno === 81005) {
                                option.status = matchedItem.status == "0";
                            } else {
                                option.status = matchedItem.status == "1";
                            }
                        }
                    });
                });
            }
            // checkeInfos.data.forEach((item) => {
            //     this.checkedObj.forEach((checkItem) => {
            //         if (item.columno == checkItem.columno) {
            //             if (item.columno == "81005") {
            //                 checkItem.status = item.status == "0";
            //             } else {
            //                 checkItem.status = item.status == "1";
            //             }
            //         }
            //     });
            // });
        },
        handleCheck() {
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(async () => {
                const resultArray = this.serviceSubscriptionArr.flatMap((group) =>
                    group.checkedObj.map(({ columno, status }) => ({ columno, status }))
                );
                let columnList = JSON.stringify(resultArray);
                columnList = JSON.parse(columnList);
                columnList.forEach((item) => {
                    if (item.columno == "81005") {
                        item.status = item.status ? "0" : "1";
                    } else {
                        item.status = item.status ? "1" : "0";
                    }
                });
                const res = await userApi.modifyCustomizedServer({
                    columnList: columnList
                });
                if (res.code == "0") {
                    this.$message({
                        type: "success",
                        message: "修改服务定制信息成功！"
                    });
                }
                this.qryCustomizedServer();
            }, 1000);
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-service-subscript {
    .service-subscript-head {
        display: flex;
        align-items: center;
        .service-subscript-head-bar {
            width: 3.71px;
            height: 16px;
            background: var(--color-primary);
        }
        .service-subscript-head-text {
            margin-left: 6.3px;
            font-size: 18px;
            font-weight: 500;
            color: var(--color-text-primary);
        }
    }

    .service-subscript-content {
        box-sizing: border-box;
        border: 1px solid var(--color-divided);
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        .el-row-common {
            // height: 50px;
            line-height: 50px;
            padding: 0 16px;
            width: 205px;
            display: inline-block;
            .single-row {
                display: flex;
                justify-content: right;
                span {
                    margin-right: 6px;
                }
            }
            .single-row-img {
                display: flex;
                align-items: center;
                img {
                    margin-right: 6px;
                }
                .single-row-img-text {
                    display: inline-block;
                    max-width: 120px;
                    margin-right: 6px;
                }
            }
        }
    }
    :deep(.el-checkbox__input) {
        .el-checkbox__inner {
            border-color: var(--color-divided) !important;
            background-color: #ffffff !important;
        }
        .el-checkbox__inner:after {
            border-color: var(--color-divided) !important;
            -webkit-transform: rotate(45deg) scaleY(1);
            transform: rotate(45deg) scaleY(1);
        }
    }
    .el-checkbox .el-checkbox__inner:not(.is-checked) {
        display: block !important; /* 确保不被隐藏 */
    }
    :deep(.is-checked) {
        .el-checkbox__inner {
            border-color: var(--color-primary) !important;
            background-color: var(--color-primary) !important;
        }
        .el-checkbox__inner:after {
            border-color: var(--color-divided) !important;
        }
    }

    .margin-l-30 {
        margin-top: 40px;
    }
}
</style>
